export const CHECKOUT_URL = 'https://aura-viva-2026.impultienda.ar/checkout';

export const PRICE = 'AR$ 14.990';

export interface Bono {
  badge: string;
  title: string;
  description: string;
  coverImage?: string;
}

export const bonos: Bono[] = [
  {
    badge: 'Bono 1',
    title: 'Planificador de Autocuidado',
    description: 'Organizá pequeños momentos para vos.',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/3D4uVpD4BA4hZfHoBVN6DV/Bono-1-Planificador-de-Autocuidado-v2.webp',
  },
  {
    badge: 'Bono 2',
    title: 'Calendario Lunar',
    description: 'Acompañá tus pausas, intenciones y cierres.',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/cfUWF77wa1XpVSqXPRaVwT/Bono-2-Calendario-Lunar.webp',
  },
  {
    badge: 'Bono 3',
    title: 'Limpieza Energética del Hogar',
    description: 'Creá un ritual consciente para tus espacios.',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/g3FTTjaMnUxhK8zd7LXagB/Bono-3-Limpieza-Energetica-del-Hogar.webp',
  },
  {
    badge: 'Bono 4',
    title: 'Diccionario de Cristales',
    description: 'Explorá asociaciones tradicionales e intenciones.',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/rUfA4T4b49aEh2bv5NRUHk/Bono-4-Diccionario-de-Cristales.webp',
  },
  {
    badge: 'Bono 5',
    title: 'Ritual de Protección',
    description: 'Generá un momento de resguardo y límites.',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/3scPKudqFRE6WSiBUAcZek/Bono-5-Ritual-de-Proteccion.webp',
  },
  {
    badge: 'Bono 6',
    title: '50 Afirmaciones',
    description: 'Elegí una frase para acompañar tu día.',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/6BePN3AZY2SzCUhBkPwTsv/Bono-6-50-Afirmaciones.webp',
  },
  {
    badge: 'Bono 7',
    title: 'Respirá en 5 Minutos',
    description: 'Hacé una pausa breve y recuperá presencia.',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/vLLswcj9voMkJSrk7hYzNv/Bono-7-Respira-en-5-Minutos.webp',
  },
  {
    badge: 'Bono 8',
    title: 'Diario de Bienestar de 30 Días',
    description: 'Registrá prácticas, emociones y observaciones.',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/699D98WqexQDKopXmVub9n/Bono-8-Diario-de-Bienestar-30-Dias.webp',
  },
];

export interface Faq {
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    question: '¿Qué recibo con mi compra?',
    answer:
      'Recibís la Guía de Autocuración Energética, el documento “Empezá acá” y 8 recursos digitales complementarios: Planificador de Autocuidado, Calendario Lunar, Limpieza Energética del Hogar, Diccionario de Cristales, Ritual de Protección, 50 Afirmaciones, Respirá en 5 Minutos y Diario de Bienestar de 30 Días. En total, 10 archivos y 97 páginas visuales.',
  },
  {
    question: '¿Es un producto físico?',
    answer:
      'No. Aura Viva 2026 es un producto 100 % digital. No se envía ningún libro, caja ni paquete por correo.',
  },
  {
    question: '¿Cómo accedo al material?',
    answer:
      'Después de confirmar el pago recibirás las instrucciones para acceder a los archivos digitales. Asegurate de ingresar correctamente tu correo y revisar también las carpetas de spam, correo no deseado o promociones.',
  },
  {
    question: '¿Necesito experiencia previa?',
    answer:
      'No. El contenido fue creado para que puedas comenzar aunque nunca hayas realizado prácticas energéticas. El documento “Empezá acá” te orienta para elegir tu primer recurso.',
  },
  {
    question: '¿Puedo usarlo desde el celular?',
    answer:
      'Sí. Los archivos pueden abrirse desde celular, tablet o computadora con cualquier aplicación compatible con documentos PDF. También podés imprimir las páginas que quieras completar a mano.',
  },
  {
    question: '¿Es una suscripción?',
    answer:
      'No. Realizás un único pago de AR$ 14.990. No existen mensualidades ni cobros recurrentes, y el acceso es de por vida.',
  },
  {
    question: '¿Cómo funciona la garantía?',
    answer:
      'Tu compra cuenta con una garantía de 7 días desde la fecha de adquisición. Si dentro de ese período considerás que el producto no es para vos, podés solicitar la garantía según las condiciones informadas.',
  },
  {
    question: '¿Reemplaza atención médica o psicológica?',
    answer:
      'No. Aura Viva 2026 es un recurso digital de bienestar y autocuidado. No realiza diagnósticos, no reemplaza atención médica o psicológica y no constituye un tratamiento.',
  },
];
